import {profileLabel, stageLabel} from '../../../shared/util/projectStageUtil';

export const STAGE_SORT_KEY = 'stageSortValue';

/** A string that sorts lexicographically in the stage's admin order; empty when the project has no stage. */
export const stageSortValue = (stage: {sortOrder?: number | null} | null | undefined): string =>
	stage?.sortOrder === null || stage?.sortOrder === undefined ? '' : String(stage.sortOrder).padStart(6, '0');

type SavedSort = {key: string; direction: number};

/** Maps a sort saved before projects were sorted by company stage onto the key the table sorts by now. */
export const resolveStageSortKey = (saved: SavedSort): SavedSort =>
	saved.key === 'stage' ? {...saved, key: STAGE_SORT_KEY} : saved;

type StageProject = {
	projectStage?: {id?: string | null; name?: string | null; sortOrder?: number | null} | null;
	stage?: string | null;
};
type StageIntl = Parameters<typeof stageLabel>[1];

/** Sorts after every padded sort order, for projects that only have the old status. */
const STATUS_ONLY_SORT_VALUE = '~';

/** The project's stage sort value; projects without a company stage (status only) sort last. */
export const projectStageSortValue = (project: StageProject): string =>
	project.projectStage ? stageSortValue(project.projectStage) : STATUS_ONLY_SORT_VALUE;

/** The stage group a project belongs to: its company stage, else its old status. */
export const projectStageGroupKey = (project: StageProject): string =>
	project.projectStage?.id ?? `status:${project.stage ?? ''}`;

/** The project's stage label: the company stage's, else the old status' profile label. */
export const projectStageLabel = (project: StageProject, intl: StageIntl): string =>
	project.projectStage ? stageLabel(project.projectStage, intl) : profileLabel(project.stage, intl);
